import { createRouter, createWebHistory } from "vue-router";
import HomeView from "./views/HomeView.vue";
import LoginView from "./views/LoginView.vue";
import AGBGenerator from "./views/AGBGenerator.vue";
import Dashboard from "./views/Dashboard.vue";
import TestView from "./views/TestView.vue";
import ImpressumShop from "./views/ImpressumShop.vue";
import DSVGOGenerator from "./views/DSVGOGenerator.vue";

const routes = [
  {
    path: "/",
    component: HomeView,
  },
  {
    path: "/login",
    component: LoginView,
  },
  {
    path: "/app",
    component: Dashboard,
  },
  {
    path: "/app/agb-generator",
    component: AGBGenerator,
  },
  {
    path: "/app/dsvgo-generator",
    component: DSVGOGenerator,
  },
  {
    path: "/app/impressum-shop",
    component: ImpressumShop,
  },
  {
    path: "/test",
    component: TestView,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
